import React from 'react';
import { Navigate, Outlet, RouteObject } from 'react-router';

import * as DeliverablesEntityConfig from './EntityConfig';
import { PermissionGuard } from '~/core/PermissionGuard';
import { Route as DeliverableRoute } from '~/core/routes/deliverables/[deliverableId]/_index';
import { Route as DeliverableReceiptRoute } from '~/core/routes/deliverables/[deliverableId]/final-output-report-versions/[receiptId]/_index';
import { Route as DeliverablesRoute } from '~/core/routes/deliverables/_index';

// Exports
export const Router: RouteObject = {
  element: (
    <PermissionGuard
      permissions={DeliverablesEntityConfig.permissions}
      fallback={<Navigate to="/" replace />}
    >
      <Outlet />
    </PermissionGuard>
  ),
  // Relative to /loans/*
  children: [
    { index: true, element: <DeliverablesRoute /> },
    { path: ':deliverableId', element: <DeliverableRoute /> },
    {
      path: ':deliverableId/final-output-report-versions/:receiptId',
      element: <DeliverableReceiptRoute />,
    },
    { path: '*', element: <Navigate to="./" replace /> },
  ],
};
